export const KNOWN_ERRORS_TO_IGNORE = [
  'Amplitude Logger [Error]: Event rejected due to exceeded retry count',
  'Amplitude Logger [Error]: Failed to fetch',
  'Amplitude Logger [Error]: Unexpected end of JSON input',
  'Amplitude Logger [Error]: NetworkError when attempting to fetch resource.',
];
